var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNightlifesvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7033 5.79236C23.3648 5.79236 23.0264 5.83467 22.6879 6.0039C23.7033 6.46928 24.3802 7.48467 24.3802 8.58467C24.3802 9.72697 23.7033 10.7424 22.6879 11.2077C23.0264 11.3347 23.3648 11.4193 23.7033 11.377C25.2264 11.377 26.4956 10.1077 26.4956 8.58467C26.4956 7.82313 26.1995 7.1462 25.6918 6.5962C25.1418 6.08851 24.4648 5.79236 23.7033 5.79236ZM8.93793 7.52697C8.811 7.23082 8.64177 6.93467 8.43023 6.68082C7.83793 6.08851 6.94947 5.91928 6.14562 6.25774C5.00331 6.68082 4.411 7.90774 4.79177 9.05005C5.00331 9.60005 5.38408 10.0231 5.93408 10.277C6.48408 10.5308 7.07639 10.5308 7.58408 10.3193",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93793 7.52697C8.811 7.23082 8.64177 6.93467 8.43023 6.68082C7.83793 6.08851 6.94947 5.91928 6.14562 6.25774C5.00331 6.68082 4.411 7.90774 4.79177 9.05005C5.00331 9.60005 5.38408 10.0231 5.93408 10.277C6.48408 10.5308 7.07639 10.5308 7.58408 10.3193M23.7033 5.79236C23.3648 5.79236 23.0264 5.83467 22.6879 6.0039C23.7033 6.46928 24.3802 7.48467 24.3802 8.58467C24.3802 9.72697 23.7033 10.7424 22.6879 11.2077C23.0264 11.3347 23.3648 11.4193 23.7033 11.377C25.2264 11.377 26.4956 10.1077 26.4956 8.58467C26.4956 7.82313 26.1995 7.1462 25.6918 6.5962C25.1418 6.08851 24.4648 5.79236 23.7033 5.79236Z",
    stroke: "#FFCC09",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2963 15.4808L6.82321 8.45774C6.69629 8.28851 6.7386 8.03467 6.99244 8.03467H21.0386C21.1655 8.03467 21.2501 8.07698 21.2924 8.2039C21.3348 8.28851 21.2924 8.41544 21.2078 8.50005L14.8194 15.4808C14.6078 15.6924 14.354 15.8193 14.0578 15.8193C13.7617 15.8616 13.5078 15.7347 13.2963 15.4808Z",
    fill: "white",
    stroke: "#CCCCCC",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47253 10.277L13.2956 15.4808C13.5071 15.6924 13.761 15.8193 14.0571 15.8193C14.3533 15.8193 14.6072 15.6924 14.8187 15.4808L19.5995 10.277H8.47253Z",
    fill: "white",
    stroke: "#CCCCCC",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0574 16.1155V24.9578",
    stroke: "#CCCCCC",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5604 24.9578H16.5527",
    stroke: "#CCCCCC",
    strokeWidth: 0.761538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightlifesvg);
export default __webpack_public_path__ + "static/media/nightlife.svg.3f2dd0aae12da4d3a793153de00ac418.svg";
export { ForwardRef as ReactComponent };